import React from 'react';

import { renderPrice } from 'utils/helper/price';
import {
  SUBCAMPAIGN_STATE_TO_LABEL_TYPE,
  getSubcampaignOfferDisplayBudget,
  isNegotiationsReopened,
  isRevoked
} from 'utils/subcampaign';
import { t } from 'utils/language';

import StatusLabel from 'components/status-label/StatusLabel';
import Tooltip from 'components/Tooltip';
import HeaderSeparator from 'modules/messenger/components/header-separator/HeaderSeparator';

import type { StatusLabelType, Subcampaign, SubcampaignOffer } from 'types';

type BlockProps = {
  offer: SubcampaignOffer | undefined | null,
  type: StatusLabelType,
  variablePaymentsAmount: number,
  stateLabel: string
};

type Props = {
  subcampaign: Subcampaign,
  variablePaymentsAmount: number
};

const MessengerSubcampaignStateBlock = ({
  offer,
  type,
  stateLabel,
  variablePaymentsAmount
}: BlockProps) => (
  <div className="messenger-subcampaign-state__block">
    <div className="messenger-subcampaign-state__text">
      {t('messenger.offer_label')}: {getSubcampaignOfferDisplayBudget(offer)}
    </div>
    <StatusLabel
      size="tiny"
      label={stateLabel}
      type={type}
    />
    {
      Boolean(variablePaymentsAmount) && (
        <Tooltip
          classNameWrapper="messenger-subcampaign-state__text"
          message={t('messenger.variable_payments_label_full')}
          width="short"
        >
          {t('messenger.variable_payments_label')}: {renderPrice(variablePaymentsAmount)}
        </Tooltip>
      )
    }
  </div>
);

export const MessengerSubcampaignState = ({
  subcampaign,
  variablePaymentsAmount
}: Props) => {
  if (!subcampaign || !subcampaign.id) {
    return null;
  }

  const state = subcampaign.state;
  const stateLabel = isRevoked(subcampaign)
    ? t(`subcampaign_state_label_revoked_by_${String(subcampaign.revokedBy)}`)
    : t(`subcampaign_state_label_${state}`);

  return (
    <div className="messenger-subcampaign-state">
      <div className="messenger-header-separator" />
      <MessengerSubcampaignStateBlock
        offer={subcampaign.offer}
        variablePaymentsAmount={variablePaymentsAmount}
        stateLabel={stateLabel}
        type={SUBCAMPAIGN_STATE_TO_LABEL_TYPE[state]}
      />
      {
        isNegotiationsReopened(subcampaign) && (
          <React.Fragment>
            <HeaderSeparator />
            <MessengerSubcampaignStateBlock
              offer={subcampaign.updatedOffer}
              variablePaymentsAmount={variablePaymentsAmount}
              stateLabel={t('negotiations_reopened_label')}
              type="warning"
            />
          </React.Fragment>
        )
      }
    </div>
  );
};

export default MessengerSubcampaignState;
